exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1gDc5T-KKgEUcDxFvQEmKR {\n  align-items: center;\n  background: url(" + require("../assets/blue-pattern.jpg") + ");\n  background-size: cover;\n  display: flex;\n  height: calc(100vh - 6rem);\n  justify-content: center;\n  padding: 2rem;\n  text-align: center;\n}\n._1hzdTYrV8qNuRZKuE1TWKV {\n  background: rgba(50,50,100,0.25);\n  flex: 0 1 auto;\n  height: auto;\n  padding: 2rem;\n  width: 30rem;\n}\n._3mNF7ok35Bk9qSGLCK93Gl {\n  color: #fafafa;\n  font-size: 2.5rem;\n  font-weight: bold;\n  padding-bottom: 2rem;\n  text-shadow: 1px 1px 1px #000;\n}\n._158ZVamXcXOxn0tZDfx_9t {\n  color: #fff;\n  text-shadow: 0 1px 1px #000;\n}\n", ""]);

// exports
exports.locals = {
	"login": "_1gDc5T-KKgEUcDxFvQEmKR",
	"form": "_1hzdTYrV8qNuRZKuE1TWKV",
	"heading": "_3mNF7ok35Bk9qSGLCK93Gl",
	"label": "_158ZVamXcXOxn0tZDfx_9t"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/stylus-loader!./src/css/login.styl
 ** module id = 259
 ** module chunks = 0
 **/